import React from 'react'
import MobileCreateTicketLayout from '../layout/Mobile/MobileCreateTicketLayout'
import MobileMainLayout from '../layout/Mobile/MobileMainLayout'

const CreateTicketPage = () => {
    return (
        <>
            <MobileMainLayout>
                <MobileCreateTicketLayout />
            </MobileMainLayout>
        </>
    )
}

export default CreateTicketPage
